module.exports = __webpack_public_path__ + "images/cm-xp-coins.jpg";